import * as borogove from "borogove";
import { isTauri } from "@tauri-apps/api/core";
import { MediaStoreTauri } from "./media-store-tauri";

export const mediaStore = isTauri()
	? new MediaStoreTauri()
	: await borogove.persistence.MediaStoreCache("snikket");
